export default "__VITE_ASSET__jqAHKoWw__"